<template>
  <div class="row border-bottom border-3 mb-2">
    <div class="col">
      <div>Business:</div>
      <h4 class="text-primary fw-bold">{{ userData.business }}</h4>
    </div>
    <div class="col">
      <div>Contact:</div>
      <h4 class="text-primary fw-bold">{{ userData.contact }}</h4>
    </div>
    <div class="col">
      <div>Balance:</div>
      <h4 v-if="fetched" class="text-primary fw-bold">{{ commas(TotalAmount - withdrawnAmount) }}</h4>
      <h4 v-else class="text-primary fw-bold">{{ 0 }}</h4>
    </div>
  </div>
</template>

<script>
import { onlineTransactionComputed, onlineTransactionMethods } from "@/state/helpers";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      fetched: false,
    }
  },
  methods: {
    ...onlineTransactionMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
  async mounted() {
    await this.fetchOnlineTransactions();
    this.fetched = true;
  },
  computed: {
    ...onlineTransactionComputed,
    TotalAmount() {
      if (this.fetched) {
        return this.onlinetransactions.reduce((a, b) => a + b.amount, 0);
      } else {
        return 0;
      }
    },
  },
}
</script>